import React, { useState, useEffect } from 'react';
import { get, post } from '../../../services/apiController';
import { Button, FloatingLabel, Form, Modal, Spinner, Table } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../../components/Breadcrumb';
import moment from 'moment';
import Factory from '../../../components/factory';
import '../grn/grnDetail.css';
import AlertIcon from '../../../../src/img.svg';
import './custom-table.css';

const StockTransfer = ({ type, title }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [pmItems, setPMItems] = useState([]);
  const [filteredPmItems, setFilterPMItems] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [kitchens, setKitchens] = useState([]);
  const [filteredKitchens, setFilteredKitchens] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState(false);
  const [finalSubmitModal, setFinalSubmitModal] = useState(false);
  const [kitchenId, setKitchenId] = useState('');
  const [filters, setFilters] = useState({
    date: moment().format('YYYY-MM-DD'),
    factoryId: 116,
    kitchenCriteria: '',
    itemsCriteria: '',
  });
  const [issuedQuantities, setIssuedQuantities] = useState({});
  const handleIssuedQuantityChange = (itemId, kitchenId, issuedQuantity) => {
    setIssuedQuantities((prevQuantities) => ({
      ...prevQuantities,
      [kitchenId]: {
        ...(prevQuantities[kitchenId] || {}),
        [itemId]: { value: issuedQuantity },
      },
    }));
  };
  const handleSubmit = (kitchenId) => {
    setView(true);
    setKitchenId(kitchenId);
  };

  const handleSave = () => {
    setLoading(true);
    post({ items: issuedQuantities[kitchenId], kitchenId, date: filters.date }, '/inv/pm-production-indent')
      .then((res) => {
        setLoading(false);
        toast.success(res?.data);
        setView(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err?.message, { autoClose: 2000 });
      });
  };

  const handleFinalSubmit = () => {
    setLoading(true);
    post({ items: issuedQuantities[kitchenId], kitchenId, date: filters.date }, '/inv/pm-production-indent/final-submit')
      .then((res) => {
        setLoading(false);
        toast.success(res?.data);
        setFinalSubmitModal(false);
        // Update stock
        const updatedPMItems = pmItems.map((item) => {
          const itemId = item.id;
          const issuedQuantity = issuedQuantities[kitchenId]?.[itemId]?.value || 0;
          const updatedItem = { ...item, quantity: item.quantity - issuedQuantity };
          return updatedItem;
        });
        setPMItems(updatedPMItems);
        setFilterPMItems(updatedPMItems);
        // reset input fields
        setIssuedQuantities({ ...issuedQuantities, [kitchenId]: {} });
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err?.message, { autoClose: 2000 });
      });
  };

  function FetchPmItems() {
    try {
      setIsLoading(true);
      get(`/inv/items/?class=Godown&factoryId=116&type=${type}`)
        .then((response) => {
          setPMItems(response.data);
          setFilterPMItems(response.data);
          setTotalRecords(response.data.length);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data?.data?.message || err.message);
        });
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.data?.message);
    }
  }

  function getKitchens() {
    get(`/inv/kitchen?factoryId=116&type=${type}`)
      .then((response) => {
        setKitchens(response?.data?.rows);
        setFilteredKitchens(response?.data?.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  }
  const fetchTempSavedItems = () => {
    setIsLoading(true);
    const currentDate = moment().format('YYYY-MM-DD');
    get(`/inv/pm-production-indent/116/?date=${filters.date}`)
      .then((response) => {
        // If any kitchen temporary indent available then set quantity
        const tempIndents = response.data;
        const updatedIssuedQuantities = {};
        const kitchenToShow = [];

        for (const indent of tempIndents) {
          const kitchenId = indent.kitchenId;
          const indentDetails = indent.indentDetails;
          kitchenToShow.push(kitchenId);

          if (!updatedIssuedQuantities[kitchenId]) {
            updatedIssuedQuantities[kitchenId] = {};
          }

          // set quantities
          for (const detail of indentDetails) {
            const { itemId, quantity } = detail;
            updatedIssuedQuantities[kitchenId][itemId] = {
              value: quantity.toString(),
            };
          }
        }
        if (currentDate !== filters.date) {
          const kits = kitchens.filter((kit) => {
            return kitchenToShow.includes(kit.id);
          });
          setFilteredKitchens(kits);
        } else {
          setFilteredKitchens(kitchens);
        }
        setIssuedQuantities(updatedIssuedQuantities);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
        setIsLoading(false);
      });
  };

  const getLocations = () => {
    get(`/branches/?type=factory`)
      .then((response) => {
        setLocationList(response.data.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  };

  const handleKitchenFilter = (criteria) => {
    setFilters({
      ...filters,
      kitchenCriteria: criteria,
    });
    if (criteria) {
      const criteriaKitchens = kitchens.filter((kit) => {
        let kitchenName = kit.name.toLowerCase();
        return kitchenName.includes(criteria.toLowerCase());
      });
      setFilteredKitchens([...criteriaKitchens]);
    } else {
      setFilteredKitchens([...kitchens]);
    }
  };

  const handleGodownItemsFilter = (criteria) => {
    setFilters({
      ...filters,
      itemsCriteria: criteria,
    });

    if (criteria) {
      const criteriaItems = pmItems.filter((item) => {
        let itemName = item.itemName.toLowerCase();
        return itemName.includes(criteria.toLowerCase());
      });
      setFilterPMItems([...criteriaItems]);
    } else {
      setFilterPMItems([...pmItems]);
    }
  };

  useEffect(() => {
    getLocations();
    FetchPmItems();
    getKitchens();
    fetchTempSavedItems();
  }, []);

  useEffect(() => {
    setFilteredKitchens(kitchens); // Set filteredKitchens with the initial data from kitchens
  }, [kitchens]);

  let serialNumber = 1;

  function ItemDetails() {
    return (
      <div className="grn-detail">
        <div className="text-center">
          <div className="mb-3">
            <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
          </div>
          <div>
            <Table bordered striped responsive className="mt-3">
              <tbody>
                <tr>
                  <th>S.No.</th>
                  <th>Item</th>
                  <th>HSN Code</th>
                  <th>Rate</th>
                  <th>Issued Quantity</th>
                </tr>
                {issuedQuantities[kitchenId] &&
                  Object.keys(issuedQuantities[kitchenId])?.map((ele, i) => {
                    const itemDetail = pmItems.find((item) => +item.id === +ele);
                    return (
                      issuedQuantities[kitchenId][ele]?.value > 0 && (
                        <tr key={i}>
                          <td>{serialNumber++}</td>
                          <td>{itemDetail?.itemName}</td>
                          <td>{itemDetail?.hsnCode}</td>
                          <td>{itemDetail?.rate}</td>
                          <td>{issuedQuantities[kitchenId][ele]?.value}</td>
                        </tr>
                      )
                    );
                  })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }

  function SaveAndSubmit({ kitchenId }) {
    return (
      <div className="d-grid justify-content-center align-items-center" style={{ height: '100%' }}>
        <Button onClick={() => handleSubmit(kitchenId)} className="btn btn-sm btn-info mx-1 mb-2">
          Save
        </Button>
        <Button
          onClick={() => {
            setFinalSubmitModal(true);
            setKitchenId(kitchenId);
          }}
          className="btn btn-sm btn-danger mx-1"
        >
          Final Submit
        </Button>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Inventory Management' },
          { link: '#', title },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-3">
            <div className="d-flex" style={{ height: '100%', alignItems: 'center' }}>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                {title} | {totalRecords ?? 0}
              </h4>
            </div>
          </div>
          <div className="card-header-actions col-9 d-flex justify-content-end">
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="Date">
                <Form.Control
                  value={filters.date}
                  onChange={(e) => setFilters({ ...filters, date: e.target.value })}
                  type="date"
                  min={moment().subtract(3, 'days').format('YYYY-MM-DD')}
                  max={moment().format('YYYY-MM-DD')}
                />
              </FloatingLabel>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel label="Factory" className="mb-3">
                <Factory
                  factoryId={filters.factoryId}
                  onChange={(e) => {
                    setFilters({ ...filters, factoryId: e.target.value });
                  }}
                  factories={locationList}
                  label="factory"
                  name="factoryId"
                  disabled
                />
              </FloatingLabel>
            </div>
            <button onClick={fetchTempSavedItems} type="button" className="btn app-btn-default dark-color ">
              Apply
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row p-3">
            <div className="col-2">
              <Form.Control
                value={filters.itemsCriteria}
                onChange={(e) => {
                  handleGodownItemsFilter(e.target.value);
                }}
                type="text"
                placeholder="Filter By Item Name"
              />
            </div>
            <div className="col-2">
              <Form.Control
                value={filters.kitchenCriteria}
                onChange={(e) => {
                  handleKitchenFilter(e.target.value);
                }}
                type="text"
                placeholder="Filter By outlet"
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                  <Spinner className="m-4" animation="border" variant="primary" />
                  <span>Loading....</span>
                </div>
              ) : (
                <div className="custom-pm-responsive-table" role="region" aria-labelledby="caption" tabindex="0">
                  <table className="text-center">
                    <thead>
                      <tr style={{ height: '4vh' }}>
                        <th>#</th>
                        <th>Godown Items</th>
                        {filteredKitchens.map((kitchen) => {
                          let kitchenName = kitchen?.name;
                          const indexOfOpenBracket = kitchenName.indexOf('(');
                          const indexOfCloseBracket = kitchenName.indexOf(')');
                          if (indexOfOpenBracket !== -1 && indexOfCloseBracket !== -1 && indexOfCloseBracket > indexOfOpenBracket) {
                            kitchenName = kitchenName.substring(indexOfOpenBracket + 1, indexOfCloseBracket);
                          }
                          return (
                            <th key={kitchen.id} style={{ minWidth: '100px', maxWidth: 'auto' }}>
                              {kitchenName}
                              <SaveAndSubmit kitchenId={kitchen.id} />
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPmItems.map((item, index) => (
                        <tr key={item?.id}>
                          <th>{index + 1}</th>
                          <th>
                            <div className="gowdown-item-name">{`${item?.itemName} (${item?.itemUnit})`}</div>
                            <div className="gowdown-item-name text-danger">Avl Qty {item?.quantity}</div>
                          </th>
                          {filteredKitchens.map((kitchen) => (
                            <td key={kitchen.id}>
                              <Form.Control
                                disabled={item?.quantity === 0}
                                value={(issuedQuantities[kitchen.id] && issuedQuantities[kitchen.id][item.id]?.value) || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleIssuedQuantityChange(item.id, kitchen.id, value.toString());
                                  }
                                }}
                                type="text"
                                placeholder="Issued Quantity"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                      <tr>
                        <th></th>
                        <th></th>
                        {filteredKitchens.map((kitchen) => (
                          <td className="text-center" key={kitchen.id} style={{ width: '150px' }}>
                            <SaveAndSubmit kitchenId={kitchen.id} />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {view && (
        <Modal size="lg" show={view} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>Issued PM Items Details</Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => setView(false)}></button>
          </Modal.Header>
          <Modal.Body>
            <ItemDetails />
          </Modal.Body>
          <Modal.Footer>
            <div className="btn-wrapper">
              <button onClick={() => setView(false)} className="btn app-btn-default btn-sm">
                Cancel
              </button>
              {loading ? (
                <Button variant="primary" disabled>
                  <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                  Loading...
                </Button>
              ) : (
                <button onClick={handleSave} className="btn app-btn-primary btn-sm">
                  Save
                </button>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {finalSubmitModal && (
        <Modal size="lg" show={finalSubmitModal} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header style={{ backgroundColor: '#90c' }} className="text-light py-2">
            <Modal.Title>Final Submit Production Indent Request</Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => setFinalSubmitModal(false)}></button>
          </Modal.Header>
          <Modal.Body>
            <ItemDetails />
            <hr />
            <div className="d-flex justify-content-start">
              <img src={AlertIcon} alt="alert icon" />
              <p className="ps-3 mb-0">Are you sure want to final submit to create production indent.</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="btn-wrapper">
              <button onClick={() => setFinalSubmitModal(false)} className="btn app-btn-default btn-sm">
                Cancel
              </button>
              {loading ? (
                <Button variant="primary" disabled>
                  <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                  Loading...
                </Button>
              ) : (
                <button disabled={loading} onClick={handleFinalSubmit} className="btn app-btn-primary btn-sm">
                  Submit
                </button>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default StockTransfer;
